export interface AuthServiceResponse {
  isUserAuthenticated: boolean;
  expiryTimeUtc: Date;
}
